import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6fmfa45v57: FaireBrandEntity = {
  token: "b_6fmfa45v57",
  type: "brand",
  name: "Gameday Social Apparel Co.®",
  avatarUrl:
    "https://cdn.faire.com/fastly/c06031440eaea772341ad4d749bcd5d356ebe65acf72f9a7fbf3ef0ebd27dcbd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cb65466bc78a7df6abd1c3f1792f638994789744e55ac717a10bd5a396a2873c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c06031440eaea772341ad4d749bcd5d356ebe65acf72f9a7fbf3ef0ebd27dcbd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cb65466bc78a7df6abd1c3f1792f638994789744e55ac717a10bd5a396a2873c.png",
  location: "Sioux Falls, SD, USA",
  minimumOrderDollars: 500,
  rating: 4.9,
  reviewCount: 54,
  isInsider: true,
  description:
    "Gameday Social®️ was born in the college town of Brookings, South Dakota, focused on trend-driven collegiate apparel. Our team has a long history in the boutique world and loves reinventing the tailgate fashion experience! In addition to our collegiate line, we also offer a select line of lifestyle garments and accessories.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:52:25.498Z",
    importedBy: "entity-db-cli",
  },
};
